import React, { useContext, useEffect, useState, useTransition } from "react";
import "./CadastrarRegrasRPA.scss";
import { useForm } from "react-hook-form";
import GlobalContext from "@context/GlobalContext";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import Button from "@components/button/Button";
import DropDownList from "@components/dropDownList/DropDownList";
import EndPointServices from "@services/ApiServices";
import MessageServices from "@services/MessageServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import Modal from "@components/modal/Modal";
import useLoading from "@hooks/useLoading";
import CheckBox from "@components/checkbox/CheckBox";

const CadastrarRegrasRPA = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingA, startTransitionA] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();
  const [isPendingC, startTransitionC] = useTransition();

  useLoading(isPending);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({});

  //Variaveis Padrões
  const [state, dispatch] = useContext(GlobalContext);

  //Modal
  const [showModal, setShowModal] = useState(false);
  const [retornoErros, setRetornoErros] = useState([]);

  //lst
  const [lstregistro, setLstRegistro] = useState([]);
  const [lstColuna, setLstColuna] = useState([]);
  const [lstColunaB, setLstColunaB] = useState([]);
  const [lstAdd, setLstAdd] = useState([]);
  const [lstOperadores, setLstOperadores] = useState([]);

  const [valueDropDownLst, setValueDropDownLst] = useState([]);
  const [valueDropDownLstB, setValueDropDownLstB] = useState([]);

  //botaocriar
  const [disabled, setDisabled] = useState([]);

  //Manual
  const [check, setCheck] = useState(false);

  //editar regra
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    handleCamposDefault();

    //Edição
    if (state?.regraselecionada.length > 0) {
      setEdit(true);
      handleVisualizarRegra(state?.regraselecionada);
    } else {
      handleConsultaRegistros();
    }

    return () => {
      setEdit(false);

      dispatch({
        type: "SET_REGRASELECIONADA",
        payload: [],
      });
    };
  }, []);

  function handleSalvar(e) {
    startTransition(async () => {
      let quando = [];

      lstAdd.map((item, index) => {
        Object.entries(e).map(([key, value]) => {
          if (key.includes(item.item)) {
            let newkey = key.split("_")[0];
            if (!quando[index]) {
              quando[index] = {};
              quando[index]["order"] = index;
            }
            if (key.includes("quandooperador_")) {
              quando[index]["id_operador"] =
                valueDropDownLstB[`quandooperador_${key.split("_")[1]}`]?.id;
            }
            quando[index][newkey] = value;
          }
        });
      });

      let dados = {
        nomeregra: e?.nomeregra,
        id_regra: edit ? state?.regraselecionada[0].id_regra : null,
        flg_alterar: edit,
        qualautomacao: valueDropDownLst?.qualautomacao?.id,
        regra: {
          registro: e?.registro,
          coluna: e?.coluna,
          de: check ? "qualquer valor" : e?.de,
          para: e?.para,
        },
        condicionais: quando,
      };
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };

      var retornoapi = await EndPointServices.Rpa_AdicionarNovaRegra(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess(
          `Regra ${edit ? "editada" : "cadastrada"} com Sucesso!`,
        );

        handleClear();
      }
    });
  }
  function handleConsultaRegistros() {
    startTransitionA(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        registro: "",
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          let dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
            id: index,
            key: item.registro,
          }));
          setLstRegistro(dados);
        }
      }
    });
  }
  function handleConsultaColuna(e) {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        registro: e,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          let dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
            id: index,
            key: item.coluna,
          }));
          setLstColuna(dados);

          return dados;
        }
      }
    });
  }
  function handleConsultaColunaB(e, coluna) {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        registro: e,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          let dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
            id: index,
            key: item.coluna,
          }));
          setLstColunaB((prevState) => ({
            ...prevState,
            [coluna]: dados,
          }));
        }
      }
    });
  }
  function handleConsultaOperadores(e, coluna) {
    startTransitionC(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };

      var retornoapi = await EndPointServices.Partilha_ConsultaOperadores(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          let dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
            id: item.id_operador,
            key: item.descoperador,
          }));

          setLstOperadores((prevState) => ({
            ...prevState,
            [coluna]: dados,
          }));
        }
      }
    });
  }
  /*Para edições*/
  async function handleVisualizarRegra(regraselecionada) {
    /*******REGISTRO PRINCIPAL.***************/
    var lstRe = await handleConsultaRegistrosEdicao();
    //NOME REGRA
    setValue("nomeregra", regraselecionada[0]?.nomeregra);

    //REGISTRO PAI
    setValue("registro", regraselecionada[0]?.registro);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      ["registro"]: lstRe?.filter(
        (item) => item.key === regraselecionada[0]?.registro,
      )[0],
    }));

    //COLUNA PAI
    var lstCol = await handleConsultaColunaEdicao(
      regraselecionada[0]?.registro,
    );
    setValue("coluna", regraselecionada[0]?.coluna);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      ["coluna"]: lstCol.filter(
        (item) => item.key === regraselecionada[0]?.coluna,
      )[0],
    }));

    //QUALQUER VALOR ou DE
    if (regraselecionada[0]?.de !== "qualquer valor") {
      setValue("de", regraselecionada[0]?.de);
    } else {
      setCheck(true);
    }
    //PARA
    setValue("para", regraselecionada[0]?.para);

    /*******REGISTRO QUANDO***************/
    const novosItens = [];
    regraselecionada.forEach((item) => {
      const uuid = UtilServices.generateUUID();
      // acumula itens para setLstAdd
      if (item.id_regra_quando) {
        novosItens.push({
          item: uuid,
          id_regra_quando: item.id_regra_quando,
          registro_quando: item.registro_quando,
          coluna_quando: item.coluna_quando,
          id_operador: item.id_operador,
          descoperador: item.descoperador,
          eou: item.eou,
          valor_quando: item.valor_quando,
        });
      }
    });

    setLstAdd((prevState) => [...prevState, ...novosItens]);

    for (const e of novosItens) {
      //REGISTRO FILHO
      setValue(`quandoregistro_${e?.item}`, e.registro_quando);
      setValueDropDownLstB((prevState) => ({
        ...prevState,
        [`quandoregistro_${e?.item}`]: lstRe.filter(
          (r) => r.key === e.registro_quando,
        )[0],
      }));

      //COLUNA FILHO
      var lstColB = await handleConsultaColunaBEdicao(
        e.registro_quando,
        `quandocoluna_${e?.item}`,
      );
      handleChangeDropDownLstB(
        `quandocoluna_${e?.item}`,
        e.coluna_quando,
        lstColB.filter((r) => r.key === e.coluna_quando)[0],
      );

      //OPERADOR
      handleChangeDropDownLstB(`quandooperador_${e?.item}`, e.descoperador, {
        id: e.id_operador,
        key: e.descoperador,
      });

      //VALOR FILHO
      setValue(`valor_${e?.item}`, e.valor_quando);

      //EOU
      if (e.eou) {
        handleChangeDropDownLstB(`eou_${e?.item}`, e.eou, {
          id: e.eou === "E" ? 1 : 2,
          key: e.eou,
        });
      }
    }
  }
  async function handleConsultaRegistrosEdicao() {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      registro: "",
    };
    let dados = [];

    var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
    if (retornoapi?.Success) {
      if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
        dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
          id: index,
          key: item.registro,
        }));
        setLstRegistro(dados);
      }
    }

    return dados;
  }
  async function handleConsultaColunaEdicao(e) {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      registro: e,
    };

    let dados = [];

    var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
    if (retornoapi?.Success) {
      if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
        dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
          id: index,
          key: item.coluna,
        }));
        setLstColuna(dados);
      }
    }

    return dados;
  }
  async function handleConsultaColunaBEdicao(e, coluna) {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      registro: e,
    };

    let dados = [];

    var retornoapi = await EndPointServices.Rpa_ConsultaRegistrosSPED(data);
    if (retornoapi?.Success) {
      if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
        dados = retornoapi.BaseReturn.LstClasse.map((item, index) => ({
          id: index,
          key: item.coluna,
        }));
        setLstColunaB((prevState) => ({
          ...prevState,
          [coluna]: dados,
        }));
      }
    }

    return dados;
  }

  /*Funções do DropDownLst.*/
  function handleCamposDefault() {
    handleChangeDropDownLst("qualautomacao", "EFD Contribuição", {
      id: 1,
      key: "EFD Contribuição",
    });
  }
  function handleChangeDropDownLst(name, value, valueAdicionar) {
    setValue(name, value);
    setValueDropDownLst((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));

    if (name.includes("registro")) {
      let coluna = "coluna";
      setValueDropDownLst((prevState) => ({
        ...prevState,
        [coluna]: "",
      }));

      handleConsultaColuna(value);
    }
  }
  function handleChangeDropDownLstB(name, value, valueAdicionar) {
    setValue(name, value);
    setValueDropDownLstB((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));

    if (name.includes("quandoregistro_")) {
      let colunaquando = name.replace("quandoregistro_", "quandocoluna_");
      setValueDropDownLstB((prevState) => ({
        ...prevState,
        [colunaquando]: "",
      }));
      handleConsultaColunaB(value, colunaquando);
    }

    if (name.includes("quandocoluna_")) {
      let colunaquando = name.replace("quandocoluna_", "quandooperador_");
      handleConsultaOperadores(value, colunaquando);
    }
  }
  function handleClear() {
    setValueDropDownLst([]);
    setValueDropDownLstB([]);
    handleCamposDefault();
    reset();
    setLstAdd([]);
  }

  return (
    <div className="cadastrarregrasrpa">
      <form onSubmit={handleSubmit(handleSalvar)} className="row">
        <div className="col-12 mt-2">
          <div className="col-md-3 col-12 mt-2 mb-4">
            <Input
              dflex={false}
              title="Nome da Regra"
              placeholder="Preencha o nome da regra"
              setValue={setValue}
              register={register}
              errors={errors}
              name="nomeregra"
              registerProps={{
                required: "Campo obrigatório",
              }}
            />
          </div>
        </div>

        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Qual Automação ?"
            setValue={setValue}
            register={register}
            errors={errors}
            name="qualautomacao"
            value={valueDropDownLst["qualautomacao"]}
            onChange={handleChangeDropDownLst}
            data={[
              { id: 1, key: "EFD Contribuição" },
              { id: 2, key: "EFD ICMS" },
            ]}
            disabled
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Registro"
            placeholder="Registro"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="registro"
            value={valueDropDownLst["registro"]}
            onChange={handleChangeDropDownLst}
            data={lstregistro}
            registerProps={{
              required: "Registro obrigatório",
            }}
            loading={isPendingA}
          />
        </div>
        <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Coluna"
            placeholder="Coluna"
            setValue={setValue}
            register={register}
            errors={errors}
            required
            name="coluna"
            value={valueDropDownLst["coluna"]}
            onChange={handleChangeDropDownLst}
            disabled={valueDropDownLst["registro"]?.key ? false : true}
            data={lstColuna}
            registerProps={{
              required: "Campo obrigatório",
            }}
            loading={isPendingB}
          />
        </div>
        <div className="col-md-6 col-12 mt-2">
          <Input
            dflex={false}
            title="De"
            placeholder="Campos vazios preencher apenas no 'Para'"
            setValue={setValue}
            register={register}
            errors={errors}
            disabled={!valueDropDownLst["coluna"]?.key || check ? true : false}
            name="de"
            tooltip
            tooltipDescricao="Se o campo a substituir estiver vazio,<br/>
                                preencha apenas o campo <strong>'Para'</strong>.<br/>
                                Nesse caso, o valor será incluído como novo."
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i className="fa-regular fa-question"></i>}
          />
          <CheckBox
            checked={check}
            className="col-md-9 col-12 mt-2"
            onChange={(e) => setCheck(e.target.checked)}
            title="Substituir por qualquer valor"
          />
        </div>
        <div className="col-md-6 col-12 mt-2">
          <Input
            dflex={false}
            title="Para"
            setValue={setValue}
            register={register}
            errors={errors}
            disabled={valueDropDownLst["coluna"]?.key ? false : true}
            name="para"
            registerProps={{
              required: "Campo obrigatório",
            }}
          />
        </div>
        <hr
          style={{
            borderTop: "1px solid #ccc",
            margin: "10px auto",
            width: "90%",
            marginTop: "50px",
          }}
        />
        {/* Quando ? */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <p className="title-quando">Condições</p>
          <i
            className="fa-regular fa-question"
            style={{ marginTop: "10px", color: "#FFDF5E", cursor: "pointer" }}
            data-tooltip-id={"tooltip-001"}
            data-tooltip-content={
              "Preencha novas condições para complementar a regra."
            }
          ></i>
        </div>
        {lstAdd.map((e, index) => {
          return (
            <div index={index} className="row">
              {index !== 0 && (
                <>
                  <hr
                    style={{
                      borderTop: "1px solid #ccc",
                      margin: "10px auto",
                      width: "90%",
                      marginTop: "20px",
                      marginBottom: "10px",
                    }}
                  />
                  <div
                    className="col-md-12 col-12 mt-2"
                    style={{ display: "flex", justifyContent: "start" }}
                  >
                    <div className="col-md-3 col-12 mt-2 mb-3 eou">
                      <DropDownList
                        title="E/OU"
                        placeholder="E/OU"
                        setValue={setValue}
                        register={register}
                        errors={errors}
                        required
                        name={`eou_${e.item}`}
                        value={valueDropDownLstB[`eou_${e.item}`]}
                        onChange={handleChangeDropDownLstB}
                        data={[
                          { id: 1, key: "E" },
                          { id: 2, key: "Ou" },
                        ]}
                        registerProps={{
                          required: "Campo obrigatório",
                        }}
                        tooltip
                        tooltipDescricao="Informe <strong>'E'</strong> ou <strong>'Ou'</strong> para definir como as condições devem funcionar juntas:<br/> - Use <strong>'E'</strong> se as duas condições precisam ser verdadeiras ao mesmo tempo.<br/> - Use <strong>'Ou'</strong> se basta que uma das condições seja verdadeira."
                        tooltipId="tooltip-001"
                        tooltipIconColor="#FFDF5E"
                        tooltipIcon={<i className="fa-regular fa-question"></i>}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3 col-12 mt-2">
                <DropDownList
                  placeholder="Registro"
                  title="Registro"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  required
                  name={`quandoregistro_${e.item}`}
                  value={valueDropDownLstB[`quandoregistro_${e.item}`]}
                  onChange={handleChangeDropDownLstB}
                  data={lstregistro}
                  registerProps={{
                    required: "Registro obrigatório",
                  }}
                  loading={isPendingA}
                />
              </div>
              <div className="col-md-3 col-12 mt-2">
                <DropDownList
                  title="Coluna"
                  placeholder="Coluna"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  required
                  name={`quandocoluna_${e.item}`}
                  value={valueDropDownLstB[`quandocoluna_${e.item}`]}
                  onChange={handleChangeDropDownLstB}
                  disabled={
                    valueDropDownLstB[`quandoregistro_${e.item}`]?.key
                      ? false
                      : true
                  }
                  data={lstColunaB?.[`quandocoluna_${e.item}`]}
                  registerProps={{
                    required: "Campo obrigatório",
                  }}
                  loading={isPendingB}
                />
              </div>
              <div className="col-md-3 col-12 mt-2">
                <DropDownList
                  title="Operadores"
                  placeholder="Operadores"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  required
                  name={`quandooperador_${e.item}`}
                  value={valueDropDownLstB[`quandooperador_${e.item}`]}
                  onChange={handleChangeDropDownLstB}
                  disabled={
                    valueDropDownLstB[`quandocoluna_${e.item}`]?.key
                      ? false
                      : true
                  }
                  data={lstOperadores?.[`quandooperador_${e.item}`]}
                  registerProps={{
                    required: "Campo obrigatório",
                  }}
                  loading={isPendingC}
                />
              </div>
              <div className="col-md-3 col-12 mt-2">
                <Input
                  dflex={false}
                  title="Valor"
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  disabled={
                    valueDropDownLstB[`quandooperador_${e.item}`]?.key
                      ? false
                      : true
                  }
                  name={`valor_${e.item}`}
                  registerProps={{
                    required: "Campo obrigatório",
                  }}
                />
              </div>
            </div>
          );
        })}
        <ButtonIcon
          Criar
          onCriar={() => {
            setLstAdd((prevState) => [
              ...prevState,
              {
                item: UtilServices.generateUUID(),
              },
            ]);
          }}
          disabledCriar={disabled?.visivel}
          typeCriar="button"
        />
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            nome={edit ? "Editar" : "Cadastrar"}
            icon={
              edit
                ? "<i class='fa-solid fa-pen'></i>"
                : "<i class='fa-solid fa-plus'></i>"
            }
            theme="2"
          />
          <ButtonIcon
            Clear
            onClear={() => {
              handleClear();
            }}
            titleClear="Limpar todos os campos."
            typeClear="button"
          />
        </div>
      </form>
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Alertas"
        width="auto"
        height="500px"
      >
        <div className="retorno-erros">
          {Object.entries(retornoErros).map(([msg, items], index) => (
            <div
              key={index}
              style={{ marginBottom: "2rem" }}
              className="grupo-erros"
            >
              <div dangerouslySetInnerHTML={{ __html: msg }} />
              {items.map((item, i) => (
                <div
                  key={i}
                  style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
                >
                  <p>
                    <strong>{item.razaosocial}</strong>
                  </p>
                  <p>{UtilServices.maskCNPJ(item.cnpj)}</p>
                </div>
              ))}
              <hr
                style={{
                  borderTop: "1px solid #ccc",
                  margin: "10px auto",
                  width: "350px",
                }}
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default CadastrarRegrasRPA;
